import { Button, Card, Grid, Modal, Text, TextInput } from '@mantine/core';
import { IconCopy, IconPencil, IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MODAL_DISPLAY_TYPES } from '../../constants/bannerChrome';
import prettifiedLabel from '../../constants/labelPrettifier';
import { SHOP_VIEWPORT_HEIGHT } from '../../helpers/previewFit';
import BannerSelector from '../Banners/BannerSelector';
import BannersDetailsForm from '../Banners/BannersDetailsForm';
import BannersNewForm from '../Banners/BannersNewForm';
import SdkPreview from '../SdkPreview';
import TagsSelect from '../TagSelector';
import previewBannerPayload from './previewBannerPayload';

const ContentBannerBlockForm = ({
  active = true,
  bannerBlock,
  banners,
  refreshBanners,
  handleStateChange,
  setUserError,
}) => {
  const banner = banners.find((b) => b.id === bannerBlock.bannerId);
  const domain = useSelector((state) => state.domain.domain);
  const [showEditBannerModal, setShowEditBannerModal] = useState();
  const [showNewBannerModal, setShowNewBannerModal] = useState();
  return (
    <Card data-tour="bannerBlockFormVisualContent" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Text size="sm" fw={500}>
              Name*
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TextInput
              name="name"
              type="text"
              value={bannerBlock.name}
              placeholder="e.g. Similar Products"
              onChange={(e) => handleStateChange(e)}
            />
          </Grid.Col>
        </Grid>

        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Text size="sm" fw={500}>
              Tags
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <TagsSelect model={bannerBlock} handleChange={handleStateChange} setUserError={setUserError} />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Text size="sm" fw={500}>
              Banner*
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <BannerSelector
              banners={banners}
              bannerId={bannerBlock.bannerId}
              onSelect={(banner) => handleStateChange({ target: { name: 'bannerId', value: banner.id } })}
            />
            <br />
            {/* `BannerBlockForm` keeps every tab's panel mounted, so this
                frame would otherwise sit off screen re-navigating and
                re-running the SDK bundle every time the Appearance tab's
                `cssStyles`/`displayType` change `previewBannerPayload`'s
                output — work nobody is there to see. `active` is false while
                this isn't the visible tab. */}
            {banner && active && (
              <SdkPreview
                method="renderBanner"
                payload={previewBannerPayload(banner, bannerBlock)}
                baseUrl={domain?.url}
                // A modal display type is `position: fixed`: it is sized by the
                // viewport and contributes no height of its own, so the frame
                // has to stand in for a shop viewport or there is nothing to
                // see. Anything else measures its own content.
                viewportHeight={
                  MODAL_DISPLAY_TYPES.includes(bannerBlock.displayType) ? SHOP_VIEWPORT_HEIGHT : undefined
                }
              />
            )}
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 2 }}>
            <Button data-tour="bannerEditBtn" fullWidth onClick={() => setShowEditBannerModal(true)} disabled={!banner}>
              <IconPencil size={14} /> Edit
            </Button>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 2 }}>
            <Button fullWidth onClick={() => setShowNewBannerModal(true)}>
              {bannerBlock.bannerId ? <IconCopy size={14} /> : <IconPlus size={14} />}{' '}
              {bannerBlock.bannerId ? 'Duplicate & Edit' : 'New'}
            </Button>
          </Grid.Col>
        </Grid>

        {banner && (
          <Modal
            size="full"
            opened={showEditBannerModal}
            onClose={() => setShowEditBannerModal(false)}
            title={`Edit ${prettifiedLabel(banner.scope || 'banner')}`}
            styles={{ content: { width: '100%', maxWidth: '100%' } }}
          >
            <BannersDetailsForm
              banner={banner}
              onSuccess={(banner) => {
                refreshBanners(null, () => {
                  handleStateChange({ target: { name: 'bannerId', value: banner.id } });
                  setShowEditBannerModal(false);
                });
              }}
              onBack={() => setShowEditBannerModal(false)}
            />
          </Modal>
        )}

        <Modal
          opened={showNewBannerModal}
          onClose={() => setShowNewBannerModal(false)}
          size="full"
          title="New Banner"
          styles={{ content: { width: '100%', maxWidth: '100%' } }}
        >
          <BannersNewForm
            from={banner?.id}
            type={prettifiedLabel(banner?.scope || 'banner')}
            onSuccess={(banner) => {
              refreshBanners(null, () => {
                handleStateChange({ target: { name: 'bannerId', value: banner.id } });
                setShowNewBannerModal(false);
              });
            }}
            onBack={() => setShowNewBannerModal(false)}
          />
        </Modal>
      </Card.Section>
    </Card>
  );
};
export default ContentBannerBlockForm;
